import { EvoModel } from './evo-model';
import { Organization } from './organization';
import { Position } from './position';

export interface ManagerSummary {
	id: string;
	name: string;
	email: string;
}

export class User extends EvoModel {

	public id: string;
	public name: string;
	public username: string;
	public email: string;
	public type: string;
	public status: any;
	public organizations: Organization[];
	public roles: any[];
	public createdAt: any;
	public updatedAt: any;

		// Preferências do usuário (ex.: themeMode: 'LIGHT' | 'DARK')
		public preferences?: { themeMode?: 'LIGHT' | 'DARK' };

	public mfaEnabled: boolean;
	public mfaRegistered: boolean;
	public isAdmin: boolean;
	public microsoftOnly: boolean;

	public position: Position | null = null;

	// Team management properties
	public manager: ManagerSummary | null = null;
	public teamLeader: boolean = false;
	public teamMembersCount: number | null = null;

	public deserialize(input: any): this {
		return super.deserialize(input);
	}
}

export enum UserStatusEnum {
	ACTIVE = <any>'Ativo',
	PENDING = <any>'Pendente',
	INACTIVE = <any>'Inativo',
	FORCE_PASSWORD_CHANGE = <any>'Troca de senha obrigatória'
}
